import React from 'react';
import BackgroundPhoto from '../Components/BackgroundPhoto';

export default function Closed() {

  return (
    <BackgroundPhoto>
      <h5>Your account has been closed.</h5>
    </BackgroundPhoto>
  );

}

